<template>
  <div style="margin-top: 20px">
    <div style="background-color: #ffffff; height: 80px">
      <div class="header-group">
        <div class="header-logo">
          <img
            src="img/logo_arvalis.png"
            alt="Logo"
            class="logo-arvalis-header"
            min-width="188"
            width="270"
            @click.prevent="router.push('/')"
          />
        </div>
        <div class="header-logo" max-width="270">
          <div class="nom-outil">Distance Riverains</div>
        </div>
      </div>
    </div>
    <!--<div class="logo-container">
      <v-col cols="10" sm="6" order="1" order-sm="1">
        <v-img
          src="@/assets/logo-arvalis.png"
          alt="Logo"
          class="logo"
          min-width="200"
          @click.prevent="router.push('/')"
        />
      </v-col>
      <v-col cols="10" sm="6" order="2" order-sm="2">
        <h1 class="tool-name">Distance Riverains</h1>
      </v-col>
    </div>-->

    <div class="nav-bar" style="margin-top: 10px">
      <div class="links">
        <router-link to="/" class="link">Accueil</router-link> |
        <router-link to="/about" class="link">En savoir plus</router-link> |
        <a
          href="https://www.arvalis.fr/outils-et-services/outils-et-fiches"
          class="link"
          target="_blank"
          >Plus d'outils</a
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import router from "@/router";
</script>
<style lang="scss">
.v-responsive.v-img {
  max-width: 13%;
}
.profil-menu {
  background-color: white;
}
.colorText {
  color: white !important;
  font-size: 0.7rem;
}
a {
  text-decoration: none;
}
.active-profil {
  //border: 1px solid green;
  background-color: lightgreen;
  font-weight: bolder !important;
}
.logo-container {
  display: flex;
  justify-content: flex-start;
  padding: 20px;
  align-items: center;
}

.logo {
  height: 60px;
  cursor: pointer;
}
.tool-name {
  margin-left: 20px;
  font-size: 1.6em;
  color: #087b7a;
}
.nav-bar {
  background-color: #087b7a;
  height: 20px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.links {
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
}

.link {
  color: white;
  text-decoration: none;
}
.header-group {
  width: 70%;
  margin: auto;
}

.logo-arvalis-header {
  position: relative;
  float: left;
  margin-right: 15px;
  top: 10px;
  z-index: 999;
}

.nom-outil {
  color: #087b7a;
  text-shadow: none;
  position: relative;
  top: 33px;
  z-index: 999;
  float: left;
  font-size: 1.8em;
  font-weight: bold;
}

.bandeau {
  background-color: #087b7a;
  height: 22px;
}

.header {
  border-bottom: 0;
  height: 80px;
  background-color: #ffffff;
  margin-bottom: 30px;
}

@media screen and (max-width: 650px) {
  .header {
    height: 120px;
  }
  .header-group {
    overflow: hidden;
    text-align: center;
  }
  .header-logo {
    width: 100%;
    overflow: hidden;
  }
  .header {
    background-color: #ffffff;
  }
  .logo-arvalis-header {
    clear: both;
    float: none;
    margin-right: 0px;
    top: 0px;
    z-index: 999;
    width: 188px;
  }
  .container_autre {
    width: 85%;
  }
  .nom-outil {
    position: static;
    float: none;
    color: #087b7a;
    text-shadow: none;
    top: 33px;
    z-index: 999;
    font-size: 1.8em;
    font-weight: bold;
  }
}
</style>
